/**
 * Correct and clean decoupling is pretty hard in complex applications.
 * So let's add a registry! When using global state, at least put it somewhere together.
 */


var Registry = function() {
	this._attributes = {};
};


Registry.prototype.get = function(key, default_value) {
	if ( typeof this._attributes[key] === "undefined" ) {
		return default_value;
	}
	return this._attributes[key];
};


Registry.prototype.set = function(key, value) {
	console.log("[Registry] Set", key, value);
	this._attributes[key] = value;
};


Registry.prototype.setAll = function(attributes) {
	this._attributes = attributes;
};


module.exports = new Registry;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/registry.js
 **/